/**
 * MEERHOO — scroll-reveal on every storefront card (respects reduced motion)
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var CARD_SELECTORS = [
    '.js-product-card',
    '[data-ce-card]',
    '.ce__card',
    '.mse__card',
    '.mse__product',
    '.cc__card',
    '.mj__figure',
    '.mj__look-item',
    '.product-grid-buywith',
    '.blog__item',
    '.article-card',
  ].join(', ');

  var EXCLUDE_ANCESTORS =
    'header, .drawer, .modal, .quickview, .loadqvpopup, #CartDrawer, .predictive-search, .mini-cart-content, .cardraw, .mh-cart-drawer';

  var cardIO = null;
  var moTimer = null;

  function cardStagger(el, idx) {
    var inline = el.style;
    var fromCe = inline.getPropertyValue('--ce-i');
    var fromMse = inline.getPropertyValue('--mse-i');
    var fromMj = inline.getPropertyValue('--mj-i');
    var fromCc = inline.getPropertyValue('--cc-i');
    var n = '0';
    if (fromCe !== '') n = fromCe;
    else if (fromMse !== '') n = fromMse;
    else if (fromMj !== '') n = fromMj;
    else if (fromCc !== '') n = fromCc;
    else n = String(idx % 8);
    el.style.setProperty('--mh-card-i', n);
  }

  function reveal(el) {
    el.classList.add('mh-visible');
    el.classList.add('mh-card-visible');
  }

  function getCardIO() {
    if (REDUCED || !('IntersectionObserver' in window)) return null;
    if (cardIO) return cardIO;

    cardIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          cardIO.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -4% 0px' }
    );

    return cardIO;
  }

  function observeCard(el) {
    if (el.classList.contains('mh-card-visible')) return;

    if (REDUCED || !getCardIO()) {
      reveal(el);
      return;
    }

    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.94 && rect.bottom > 16) {
      reveal(el);
      return;
    }

    getCardIO().observe(el);
  }

  function markScrollCards() {
    var seen = 0;
    document.querySelectorAll(CARD_SELECTORS).forEach(function (el) {
      if (el.closest(EXCLUDE_ANCESTORS)) return;
      /* Horizontal carousel: reveal all at once — no per-card slide-up while swiping */
      if (el.closest('.ce--loved, [data-ce-carousel]')) {
        el.classList.add('mh-scroll-card');
        reveal(el);
        return;
      }
      if (!el.classList.contains('mh-scroll-card')) {
        el.classList.add('mh-scroll-card');
        cardStagger(el, seen);
        seen += 1;
      }
      observeCard(el);
    });
  }

  function markSections() {
    document.querySelectorAll('.shopify-section').forEach(function (el) {
      if (el.closest('header')) return;
      if (el.querySelector('.ce, .mse, .mj, .mep, .re, .cc')) return;
      if (el.classList.contains('mh-reveal-section')) return;
      el.classList.add('mh-reveal-section');
    });
  }

  function bootSectionReveal() {
    var targets = document.querySelectorAll('.mh-reveal-section, [data-mh-reveal]');
    if (!targets.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -4% 0px' }
    );

    targets.forEach(function (el) {
      if (el.classList.contains('mh-visible')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 40) reveal(el);
      else io.observe(el);
    });
  }

  function watchDom() {
    if (!('MutationObserver' in window)) return;
    var root = document.getElementById('MainContent') || document.body;
    var mo = new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(markScrollCards, 80);
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  function init() {
    markScrollCards();
    markSections();
    bootSectionReveal();
    watchDom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
